import { useState, useCallback } from 'react';
import { Table } from 'reactstrap';
import ValidatedSelect from '../common/forms/ValidatedSelect';
import { FormCheckbox } from '../common/forms/FormElements';
import { ChargeTypeResourceTypes } from '../Common';

export const EstimateChargeTypeGrid = ({
    chargeTypes: initialChargeTypes,
    resourceTypes,
    equipmentTypes,
    rentalUnitTypes,
    resGroups,
    isProjectContract,
}) => {
    const [chargeTypes, setChargeTypes] = useState(initialChargeTypes || []);

    const handleUpdateChargeType = useCallback((uniquekey, field, value) => {
        const updated = [...chargeTypes];
        const index = updated.findIndex((chargeType) => chargeType.uniquekey === uniquekey);

        if (field == 'equipmentTypes') {
            updated[index][field] = value.map((x) => x.value);
        } else {
            updated[index][field] = value;
        }

        setChargeTypes(updated);
    }, [chargeTypes]);

    return (
        <div>

            <Table
                className="table table-sm bg-white"
                bordered
                responsive
            >
                <thead>
                    <tr>
                        <th style={{ width: '35%' }}>Description</th>
                        <th style={{ width: '20%' }}>
                            Resource Type
                        </th>
                        <th>
                            Eligible Equipment Types/Resource Groups
                        </th>
                        {isProjectContract && (
                            <th style={{ width: '20%' }}>
                                Rental Unit
                            </th>
                        )}
                        <th style={{ width: '20%' }}>
                            Is Taxable
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {chargeTypes.length === 0 ? (
                        <tr>
                            <td
                                colSpan={3}
                                className="text-center"
                            >
                                No new charge types found.
                            </td>
                        </tr>
                    ) : (
                        chargeTypes.map((ct) => (
                            <tr key={ct.uniquekey}>

                                <td>
                                    {ct.memo}
                                </td>
                                <td>
                                    <ValidatedSelect
                                        id="resourcetypeid"
                                        name="resourcetypeid"
                                        required
                                        options={resourceTypes}
                                        menuPortalTarget={document.body}
                                        value={
                                            (resourceTypes ?? []).find(
                                                (x) => x.value
                                                    === ct.resourcetypeid,
                                            ) ?? ''
                                        }
                                        onChange={(e) =>
                                            handleUpdateChargeType(ct.uniquekey, 'resourcetypeid', e?.value ?? null)
                                        }
                                        error="Resource type is required."
                                    />
                                </td>
                                <td>
                                    {(ct.resourcetypeid === ChargeTypeResourceTypes.Employee) && (

                                        <ValidatedSelect
                                            id="resourcegroupid"
                                            name="resourcegroupid"
                                            required
                                            options={resGroups}
                                            menuPortalTarget={document.body}
                                            value={
                                                (resGroups ?? []).find(
                                                    (x) => x.value
                                                        === ct.resourcegroupid,
                                                ) ?? ''
                                            }
                                            onChange={(e) =>
                                                handleUpdateChargeType(ct.uniquekey, 'resourcegroupid', e?.value ?? null)
                                            }
                                            error="Eligible resource group is required."
                                        />
                                    )}
                                    {(ct.resourcetypeid === ChargeTypeResourceTypes.Equipment || ct.resourcetypeid === ChargeTypeResourceTypes.Rental) && (

                                        <ValidatedSelect
                                            id="equipmentTypes"
                                            name="equipmentTypes"
                                            required
                                            isMulti
                                            options={equipmentTypes}
                                            menuPortalTarget={document.body}
                                            value={
                                                (equipmentTypes ?? []).filter((x) => (
                                                    ct.equipmentTypes ?? []
                                                ).includes(x.value)) ?? ''
                                            }
                                            onChange={(e) =>
                                                handleUpdateChargeType(ct.uniquekey, 'equipmentTypes', e ?? null)
                                            }
                                            error="Eligible equipment type is required."
                                        />
                                    )}
                                </td>
                                {isProjectContract && (
                                    <td>
                                        {ct.resourcetypeid === ChargeTypeResourceTypes.Rental && (
                                            <ValidatedSelect
                                                id="rentalunit"
                                                name="rentalunit"
                                                required
                                                options={rentalUnitTypes}
                                                menuPortalTarget={document.body}
                                                value={
                                                    (rentalUnitTypes ?? []).find(
                                                        (x) => x.value
                                                            === ct.rentalunit,
                                                    ) ?? ''
                                                }
                                                onChange={(e) =>
                                                    handleUpdateChargeType(ct.uniquekey, 'rentalunit', e?.value ?? null)
                                                }
                                                error="Rental unit is required."
                                            />
                                        )}
                                    </td>
                                )}
                                <td>
                                    <FormCheckbox
                                        className="ml-3 w-auto"
                                        id={`${ct.uniquekey}isTaxable`}
                                        name={`${ct.uniquekey}isTaxable`}
                                        checked={ct.isTaxable ?? ''}
                                        onChange={(e) =>
                                            handleUpdateChargeType(ct.uniquekey, 'isTaxable', e.target.checked)
                                        }
                                    />
                                </td>
                            </tr>

                        )))}
                </tbody>
            </Table>
        </div>
    );
};
